// ─────────────────────────────────────────────────────────────
// ABERCAL — "THE AI STUDIO" SHOWCASE CONFIG
// Owner edit guide: add one line per piece. Three types:
//
//   IMAGE:  { type: "image", title: "...", src: "IMAGE_URL", caption: "..." }
//   VIDEO:  { type: "video", title: "...", src: "VIDEO_URL.mp4", poster: "IMAGE_URL" }  // uploaded mp4, hover to play
//   EMBED:  { type: "embed", title: "...", url: "https://youtu.be/ID  or  https://vimeo.com/ID" }  // YouTube / Vimeo
//
// Delete a line to remove a piece. Empty the array to show the elegant empty state.
// ─────────────────────────────────────────────────────────────

export const aiShowcaseItems = [
  { type: "video", title: "Deconstructed Poutine", src: "/ai-video-4.mp4", poster: "/ai-video-4-poster.jpg" },
  { type: "video", title: "The Carrot", src: "/ai-video-5.mp4", poster: "/ai-video-5-poster.jpg" },
  { type: "image", title: "Cinematic Portrait — Tokyo Alley", src: "/ai-image-2.webp", caption: "AI photography concept" },
  { type: "video", title: "Logo Reveal — Mr. Barber", src: "/ai-video-3.mp4", poster: "/ai-video-3-poster.jpg" },
  { type: "image", title: "Chromatic Highland", src: "/ai-image-3.png", caption: "AI fine-art concept" },
  { type: "video", title: "Luxury Home Tour", src: "/ai-video-2.mp4", poster: "/ai-video-2-poster.jpg" },
  { type: "image", title: "Editorial Concept — Monochrome Red", src: "/ai-image-1.png", caption: "AI character & fashion concept" },
  { type: "video", title: "Lifestyle Brand Film", src: "/ai-video-1.mp4", poster: "/ai-video-1-poster.jpg" },
  { type: "image", title: "Editorial Concept — Monochrome Yellow", src: "/ai-image-4.png", caption: "AI character & fashion concept" },
];
